export default "__VITE_ASSET__sQzE4trI__"